var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{attrs:{"title":"Sugerencia para catálogo de Mercado Libre","title-link":_vm.link,"map":[
      !_vm.integrationConfigLabel ? 'loading' : _vm.integrationConfigLabel,
      'Sugerencias de catálogo',
      _vm.$route.meta.action
    ],"title-size":12}}),_c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('router-view',{attrs:{"integration-config-id":_vm.integrationConfigId}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }